import { useMutation, useQuery } from '@apollo/client';

import {
  Box,
  Center,
  Spinner,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  Textarea,
  Button,
  Select,
  useDisclosure,
  useToast,
  VStack,
  HStack,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';

import moment from 'moment';

import { useState } from 'react';

import {
  GET_MEMBERS_BY_LAST_INITIAL,
} from '../../../../Queries';

import { useUser } from '../../../../Context';

import { EditMemberModal } from './EditMemberModal';

export const Members = () => {
  const { user } = useUser();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [openEditMember, setOpenEditMember] = useState(null);

  const [initial, setInitial] = useState('A');

  /* Query Members */
  const { loading, error, data } = useQuery(GET_MEMBERS_BY_LAST_INITIAL, {
    variables: {
      initial,
    }
  });
  
  return (
    loading ? (
      <Center>
        <Spinner />
      </Center>
    ) : (
      <VStack>
        <Button
          onClick={() => {
            onOpen();
            setOpenEditMember({});
          }
        }>
          Add New
        </Button>
        <Wrap>
          {String.fromCharCode(...Array(123).keys()).slice(97).split("").map((letter) => (
            <WrapItem>
              <Button p={2} minW="auto" variant="link" textDecoration={letter?.toUpperCase() === initial ? 'underline' : null} onClick={() => setInitial(letter?.toUpperCase())}>
                {letter?.toUpperCase()}
              </Button>
            </WrapItem>
          ))}
        </Wrap>
        <TableContainer>
          <Table variant='simple'>
            <TableCaption>Members</TableCaption>
            <Thead>
              <Tr>
                <Th>Username</Th>
                <Th>Email</Th>
                <Th>First Name</Th>
                <Th>Last Name</Th>
                <Th>Member Type</Th>
                <Th>Member Since</Th>
                <Th>Paid Through</Th>
                <Th>Signup Status</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data?.getMembersByLastInitial?.members ? [...data.getMembersByLastInitial.members].sort((m1, m2) => (m1.member_details.member_last_name.toLocaleUpperCase().localeCompare(m2.member_details.member_last_name.toLocaleUpperCase()))).map((member) => (
                <Tr key={member?.member_email}>
                  <Td>
                    <Button
                      onClick={() => {
                        onOpen();
                        setOpenEditMember(member);
                      }
                    }>
                      {member?.member_details?.cognito_user_id || 'No Cognito User'}
                    </Button>
                  </Td>
                  <Td>{member?.member_details?.member_email}</Td>
                  <Td>{member?.member_details?.member_first_name}</Td>
                  <Td>{member?.member_details?.member_last_name}</Td>
                  <Td>{member?.member_details?.member_type}</Td>
                  <Td>{member?.member_details?.member_since ? moment.utc(member?.member_details?.member_since * 1000).format('MM/DD/YYYY') : 'Null'}</Td>
                  <Td>{member?.member_details?.paid_through ? moment.utc(member?.member_details?.paid_through * 1000).format('MM/DD/YYYY') : 'Null'}</Td>
                  <Td>
                    <Box 
                      px={2} 
                      py={1} 
                      borderRadius="md" 
                      bg={
                        member?.member_details?.signup_status === 'COMPLETED' ? 'green.100' :
                        member?.member_details?.signup_status === 'PENDING' ? 'yellow.100' :
                        'gray.100'
                      }
                      color={
                        member?.member_details?.signup_status === 'COMPLETED' ? 'green.800' :
                        member?.member_details?.signup_status === 'PENDING' ? 'yellow.800' :
                        'gray.800'
                      }
                    >
                      {member?.member_details?.signup_status || 'N/A'}
                    </Box>
                  </Td>
                </Tr>
              )) : null}
            </Tbody>
          </Table>
        </TableContainer>
        <EditMemberModal isOpen={isOpen} onClose={onClose} openEditMember={openEditMember} setOpenEditMember={setOpenEditMember} />
      </VStack>
    )
  )
};
